export default "__VITE_ASSET__BqQhdXn1__"